import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/auth/AuthContext";
import "react-toastify/dist/ReactToastify.css";
import {
  Button,
  ChoiceGroup,
  PublicPage,
  TextField,
} from "../components/design";
import "./forgotPassword.css";
import useTranslator from "../hooks/useTranslator";
import axiosInstance from "../services/authWrapper";
import { toast } from "../helper/common";

const ForgotPassword = () => {
  const { _t } = useTranslator();

  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { setUserType } = authContext;

  const [pageCount, setPagecount] = useState(0);
  const [useremail, setUseremail] = useState({
    email: "",
    checkedTenant: false,
    checkedLandlord: false,
  });
  const [changepassword, setChangepassword] = useState({
    id: "",
    otp: "",
    type: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const handleUsertype = (e) => {
    setUserType(e.target.value);
    if (e.target.value == "landlord") {
      setUseremail({
        ...useremail,
        checkedLandlord: true,
        checkedTenant: false,
        type: "landlord",
      });
      setChangepassword({ ...changepassword, type: "landlord" });
    }
    if (e.target.value == "tenant") {
      setUseremail({
        ...useremail,
        checkedLandlord: false,
        checkedTenant: true,
        type: "tenant",
      });
      setChangepassword({ ...changepassword, type: "tenant" });
    }
  };

  const onChange_getUser = (e) => {
    setUseremail({ ...useremail, [e.target.name]: e.target.value });
  };
  const onSubmit_getuser = async (e) => {
    e.preventDefault();
    if (
      useremail.checkedLandlord == false &&
      useremail.checkedTenant == false
    ) {
      toast.error(_t("pleaseSpecifyUserType"));
    }
    await axiosInstance
      .post(`${process.env.REACT_APP_SERVER_URL}/users/find-user`, useremail, {
        headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
      })
      .then((res) => {
        setChangepassword({ ...changepassword, id: res.data.user._id });
        toast.success(_t("otpSentToYourRegisteredEmailId"));
        setPagecount(1);
      })
      .catch((err) => {
        let serverResponse = err;
        toast.error(serverResponse.response.data.status);
      });
  };
  const onChange = (e) => {
    setChangepassword({ ...changepassword, [e.target.name]: e.target.value });
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    await axiosInstance
      .post(
        `${process.env.REACT_APP_SERVER_URL}/users/change-password/`,
        changepassword,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        toast.success(res.data.msg);
        navigate("/auth");
      })
      .catch((err) => {
        let serverResponse = err;
        toast.error(serverResponse.response.data.msg);
      });
  };

  const userType = useremail.checkedTenant
    ? "tenant"
    : useremail.checkedLandlord
      ? "landlord"
      : "";

  if (pageCount == 0) {
    return (
      <PublicPage width="sm" title={_t("forgotPassword")}>
        <form className="forgot-password__form" onSubmit={onSubmit_getuser}>
          <TextField
            id="forgot-email"
            label={_t("username")}
            name="email"
            placeholder="demo@xyz"
            onChange={onChange_getUser}
          />
          <ChoiceGroup
            name="usertype"
            value={userType}
            onChange={handleUsertype}
            options={[
              { value: "tenant", label: _t("tenant") },
              { value: "landlord", label: _t("landlord") },
            ]}
          />
          <Button type="submit" size="lg" block>
            {_t("searchMyAccount")}
          </Button>
        </form>
      </PublicPage>
    );
  }

  if (pageCount == 1) {
    return (
      <PublicPage width="sm" title={_t("forgotPassword")}>
        <form className="forgot-password__form" onSubmit={onSubmit}>
          <TextField
            id="forgot-email"
            label={_t("username")}
            name="email"
            placeholder="demo@xyz"
            readOnly={true}
            value={useremail.email}
            onChange={onChange}
          />
          <TextField
            id="forgot-otp"
            label={_t("enterOtp")}
            type="number"
            name="otp"
            placeholder="******"
            onChange={onChange}
          />
          <TextField
            id="forgot-password"
            label={_t("password")}
            type="password"
            name="password"
            placeholder="*********"
            onChange={onChange}
          />
          <TextField
            id="forgot-confirm-password"
            label={_t("confirmPassword")}
            type="password"
            name="confirmPassword"
            placeholder="*********"
            onChange={onChange}
          />
          <Button type="submit" size="lg" block>
            {_t("changePassword")}
          </Button>
        </form>
      </PublicPage>
    );
  }
};

export default ForgotPassword;
